var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "clear",
    fillRule: "evenodd",
    d: "M8 1.28a3.627 3.627 0 1 0 0 7.253A3.627 3.627 0 0 0 8 1.28m2.67 7.745a4.907 4.907 0 1 0-5.338 0A7.47 7.47 0 0 0 .532 16h1.28a6.187 6.187 0 1 1 12.374 0h1.28a7.47 7.47 0 0 0-4.798-6.975",
    clipRule: "evenodd"
  })));
};
export default SvgPerson;